/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import FormRow from '../../../../components/FormRow'
import FormCol from '../../../../components/FormCol'
import Typography from '@material-ui/core/Typography'
import {
  SimpleForm,
  TextInput,
  Edit,
  required,
  NumberInput,
  useGetOne,
  useDataProvider,
  Toolbar,
  SaveButton,
  SelectInput,
  TopToolbar,
  useNotify,
  useRedirect,
  useRefresh,
  ListButton,
} from 'react-admin'
import StyledInput from '../../../../components/StyledInput'
import { RunnersScheduleEdit } from './RunnersScheduleEdit'
import VisitDeleteButton from '../../../../components/VisitDeleteButton'
import { makeStyles } from '@material-ui/core/styles'
import VisitFeedbackButton, { outcomeChoices } from '../../../../components/VisitFeedbackButton'

export const EditVisit = (props) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const redirect = useRedirect()
  const refresh = useRefresh()
  const [leadProperty, setLeadProperty] = useState(null)
  const { data } = useGetOne('visits', props.id)
  const [visit, setVisit] = useState(null)
  const [propertyId, setPropertyId] = useState(null)
  const [property, setProperty] = useState(null)

  useEffect(() => {
    setVisit(data)
  })

  useEffect(() => {
    setPropertyId(visit?.property_id)
    if (visit?.property_id) {
      dataProvider
        .getOne('properties', { id: visit.property_id })
        .then(({ data }) => {
          setProperty(data)
        })
        .catch((error) => {
          console.error(error)
          setProperty(null)
        })
      dataProvider
        .getList('leadProperties', { filter: { property_id: visit.property_id }, pagination: {} })
        .then(({ data }) => {
          if (data[0]) {
            setLeadProperty(data[0])
          }
        })
        .catch((error) => {
          console.error(error)
          setLeadProperty(null)
        })
    }
  }, [visit])

  const visitsPath = `/leadProperties/` + leadProperty?.id + `/visits`

  const onSuccess = () => {
    notify('Inspection updated', 'info', { smart_count: 1 }, true)
    redirect(visitsPath)
  }

  const onFailure = (error) => {
    notify(`An Error occured while updating inspection  ${error}`, 'error', { smart_count: 1 }, true)
    refresh()
  }

  const CustomToolbar = (props) => {
    const useStyles = makeStyles({
      spacer: {
        flex: 1,
      },
    })

    const classes = useStyles()
    return (
      <Toolbar {...props}>
        <SaveButton onSuccess={onSuccess} onFailure={onFailure} />
        <ListButton label="Back" basePath={visitsPath} style={{ float: 'right' }} />
        <span className={classes.spacer} />
        <VisitDeleteButton basePath="/visits" />
      </Toolbar>
    )
  }

  const VisitActions = ({ record }) => {
    return <TopToolbar>{record && <VisitFeedbackButton {...props} record={record} />}</TopToolbar>
  }

  return (
    <Edit {...props} record={visit} title="Edit Inspection" resource="visits" actions={<VisitActions record={visit} />}>
      <SimpleForm redirect="edit" toolbar={<CustomToolbar />}>
        <Typography variant="h6" gutterBottom>
          Edit Inspection
        </Typography>
        <FormRow>
          <FormCol xs={12} sm={12} md={8} lg={8}>
            <StyledInput
              component={NumberInput}
              helperText={
                ' Address:' + property?.address?.street + ' ' + property?.address?.street_number + ' ' + property?.address?.city
              }
              source="property_id"
              initialValue={propertyId}
              disabled
            />
            <StyledInput
              component={TextInput}
              visible="false"
              style={{ visibility: 'hidden', height: '0px' }}
              source="lead_property_id"
              initialValue={leadProperty?.id}
              disabled
            />
          </FormCol>
          <FormCol xs={12} sm={12} md={8} lg={8}>
            <StyledInput
              component={TextInput}
              source="subject"
              validate={[required()]}
              disabled
              initialValue=""
              label="Subject"
            />
          </FormCol>
          <FormCol xs={12} sm={12} md={8} lg={8}>
            <StyledInput component={TextInput} source="description" initialValue="" label="Description" />
          </FormCol>
          <FormCol xs={12} sm={12} md={8} lg={8}>
            <StyledInput component={TextInput} source="status" disabled={true} />
          </FormCol>
        </FormRow>
        <FormRow>
          <FormCol xs={12} sm={12} md={8} lg={2}>
            <StyledInput component={SelectInput} choices={outcomeChoices} required={true} source="outcome" disabled={true} />
          </FormCol>
          <FormCol xs={12} sm={12} md={8} lg={6}>
            <StyledInput component={TextInput} multiline={true} required={true} source="comment" disabled={true} />
          </FormCol>
        </FormRow>
        <RunnersScheduleEdit propertyId={propertyId} record={visit} />
      </SimpleForm>
    </Edit>
  )
}
